module.exports = __webpack_public_path__ + "static/img/zhutuAVM.cc3e3a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/type1-2/zhutuAVM.png
// module id = ndti
// module chunks = 0